const Config = {
  APIBASEURL: process.env.REACT_APP_DEV_MODE,
};

export default Config;